// extracted by mini-css-extract-plugin
export default {"rightAlignedButton":"rightAlignedButton---kVDgS","alertDetails":"alertDetails---b3iua","lastRow":"lastRow---IuB5w"};